// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__w2BdS","containerQuiz":"Quiz_containerQuiz__vy1zV"};